/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ADMIN_SCOPE } from "../data/constants";
import { AppPermission } from "../data/emus";
import { Application } from "../data/interfaces";

export class ApplicationPermission {

    static hasPermission( permission: AppPermission, 
        application?: Application, 
        userInfo?: any, 
        allowedScopes?: string): boolean {
        if (allowedScopes) {
            const splittedScopeList = allowedScopes.split(' ');
            if (allowedScopes.includes(ADMIN_SCOPE)) {
                return true;
            }
        }    

        if (application) {
            return (application.owner === userInfo?.sub) || !!application.sharedPermissions?.includes(permission);
        }
        return false;
    }

}
